import { AnyObject } from "../../interfaces/anyObject";

interface MegaMenuResultTemplatesType {
  [key: string]: AnyObject;
}

const MegaMenuResultTemplates: MegaMenuResultTemplatesType = {};

MegaMenuResultTemplates.KontentItemArticleDonorArea = require("./items/megaMenuResultDonorArea").default;
MegaMenuResultTemplates.KontentItemArticlePageLearn = require("./items/megaMenuResultLearn").default;
MegaMenuResultTemplates.KontentItemProgram = require("./items/megaMenuResultProgram").default;
MegaMenuResultTemplates.KontentItemTargetGroupPage = require("./items/megaMenuResultTargetGroupPage").default;

export default MegaMenuResultTemplates;
